export default __webpack_public_path__ + "static/loomis_esq.svg";